import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Caption, ColoredBlock } from '@mmsg/louie'
import {
  isDateValid,
  formatCurrency,
  capitalizeEachFirstLetter,
  IsVehicleElectric,
} from '../../../helpers'
import ContactUsDialog from '../../dialog/contactUsDialog'
import SpartaCustomerCount from './spartaCustomerCount'
import { ImageBase64 } from '../../image/image'
import { Link } from 'react-router-dom'
import { applicationRoles } from '../../../constants/actionTypes'
import { Icon } from 'icons'
import { Separator } from 'components/styledComponents/Separator'
import {
  EstimateItemStyled,
  CarImageStyled,
  Heading2,
  Heading3,
  CardHeader,
  CardBody,
  SpartaCardHeader,
  EstimateItemPrimaryButton,
  EstimateItemInfoBlock,
  SpartaBlock,
  LinkContainer,
  ImageText,
  TickItemDiv,
  ReleaseCard,
  OlyCaption
} from './estimateItemStyled'

export const EstimateItem = (props) => {
  const vehicleType = props.estimate.vehicleType === 'New' ? 'New' : 'Used'
  const vehicleName = props.estimate.vehicle.id
    ? `${vehicleType} ${props.estimate.vehicle.year} ${props.estimate.vehicle.make} ${props.estimate.vehicle.family}`
    : props.estimate.vehicleDescription
  const userEmployer = props.userEmployer

  let leaseTerm = props.hasNonIntegralYearTerm
    ? props.estimate.leaseTerm.toString() + ' Months'
    : props.estimate.leaseTermYears.toString() + ' Years'

  let estimateDetailsURL = props.isConsultant
    ? '/consultant/estimates/' + props.estimate.id
    : '/estimates/' + props.estimate.id
  let notificationElement = document.getElementById('notification')
  if (notificationElement !== undefined && notificationElement !== null) {
    document.getElementById('notification').style.display = 'none'
  }
  
  let isEVRebate = userEmployer.employerGRS.evRebateApplicable && IsVehicleElectric(props.estimate, false) && props.estimate.vehicle.vehicleType &&
  props.estimate.vehicle.vehicleType.toLowerCase().includes('new')

  let invalid
  if (
    props.proposal &&
    props.proposal.isValid === false &&
    props.proposal.quoteId == props.estimate.id
  ) {
    // Marks the estimate as inactive if proposal is invalid
    invalid = true
  } else if (
    props.proposal &&
    props.proposal.isValid &&
    props.proposal.quoteId
  ) {
    invalid = props.estimate.id != props.proposal.quoteId
  } else if (!props.estimate.isValid) {
    invalid = true
  } else {
    invalid = false
  }

  let isSpartaVehicle =
    !invalid &&
    props.estimate.vehicle.id &&
    props.estimate.vehicle.shadowPR &&
    props.estimate.vehicle.spartaDetail &&
    props.estimate.vehicle.spartaDetail.offerActive

  let spartaVehicleDetail = props.estimate.vehicle.spartaDetail

  if (
    isSpartaVehicle &&
    spartaVehicleDetail &&
    !spartaVehicleDetail.offerActive
  )
    invalid = true

  let line1
  let line2
  let icon
  if (isSpartaVehicle) {
    line1 = 'Limited availability.'

    if (
      spartaVehicleDetail &&
      spartaVehicleDetail.numberOfCustomerOffered > 5
    ) {
      line2 =
        spartaVehicleDetail.numberOfCustomerOffered + ' others interested now'
      icon = <Icon iconType="Flame" />
    }
  } else if (isEVRebate)
  {
    line1 = `This car may get you a ${formatCurrency(userEmployer.employerGRS.evRebateValue, true)} EV Bonus!`
    icon = <Icon iconType="EVBolt" />
  }


  const TickItem = (props) => {
    return (
      <TickItemDiv>
        <div className="pr-1">
          <Icon iconType="PinkTick" />
        </div>
        <span> {props.text}</span>
      </TickItemDiv>
    )
  }

  let estimateCardHeaderText = () => {
    if (invalid) {
      return 'Estimate inactive'
    } else if (
      props.estimate.isValid &&
      props.proposal &&
      props.estimate.id === props.proposal.quoteId &&
      ((isDateValid(props.proposal.acceptedOn) &&
        !isDateValid(props.proposal.cancelledOn)) ||
        new Date(props.proposal.acceptedOn) >
          new Date(props.proposal.cancelledOn))
    ) {
      return 'Proposal accepted'
    } else if (
      props.estimate.isValid &&
      props.proposal &&
      props.estimate.id === props.proposal.quoteId &&
      (!isDateValid(props.proposal.acceptedOn) ||
        isDateValid(props.proposal.cancelledOn) ||
        new Date(props.proposal.cancelledOn) >
          new Date(props.proposal.acceptedOn))
    ) {
      return 'Proposal created'
    } else {
      return 'Enquiry Number #' + props.estimate.nlQuoteNumber
    }
  }

  let isProposal = estimateCardHeaderText().startsWith('Proposal')

  const isRelease = false
  {
    /*uncomment the below line when release is enabled*/
  }
  {
    /*ToDo: useSelector(
    (state) =>
      state.opportunity.channel &&
      state.opportunity.channel.toLowerCase() == 'release'
  )*/
  }

  let estimateCardHeaderClass = () => {
    if (invalid) {
      return 'estimate-item'
    } else {
      if ((isSpartaVehicle && !isProposal ) || isEVRebate) {
        return 'estimate-item highlight spartaHighlight'
      } else {
        return 'estimate-item highlight'
      }
    }
  }

  let getLeaseType = () => {
    if (props.estimate.vehicle.id) {
      if (
        props.estimate &&
        props.estimate.vehicle &&
        props.estimate.vehicle.vehicleType &&
        props.estimate.vehicle.vehicleType.toLowerCase().includes('new')
      ) {
        return 'New Car Lease'
      } else if (
        props.estimate &&
        props.estimate.vehicle &&
        props.estimate.vehicle.vehicleType &&
        props.estimate.vehicle.vehicleType.toLowerCase().includes('residual')
      ) {
        return 'Refinance Existing Lease'
      } else if (
        props.estimate &&
        props.estimate.vehicle &&
        props.estimate.vehicle.vehicleType &&
        props.estimate.vehicle.vehicleType.toLowerCase().includes('leaseback')
      ) {
        return 'Lifestyle Lease'
      } else if (
        props.estimate &&
        props.estimate.vehicle &&
        props.estimate.vehicle.vehicleType &&
        props.estimate.vehicle.vehicleType.toLowerCase().includes('private')
      ) {
        return 'Private Purchase Sale'
      } else {
        return 'Used Car Lease'
      }
    } else {
      if (
        props.estimate &&
        props.estimate &&
        props.estimate.vehicleType &&
        props.estimate.vehicleType.toLowerCase().includes('new')
      ) {
        return 'New Car Lease'
      } else if (
        props.estimate &&
        props.estimate.vehicleType &&
        props.estimate.vehicleType.toLowerCase().includes('residual')
      ) {
        return 'Refinance Existing Lease'
      } else if (
        props.estimate &&
        props.estimate.vehicleType &&
        props.estimate.vehicleType.toLowerCase().includes('leaseback')
      ) {
        return 'Lifestyle Lease'
      } else if (
        props.estimate &&
        props.estimate.vehicleType &&
        props.estimate.vehicleType.toLowerCase().includes('private')
      ) {
        return 'Private Purchase Sale'
      } else {
        return 'Used Car Lease'
      }
    }
  }

  const vehicleDescriptionContent = [
    {
      heading: 'Vehicle Description',
      content: props.estimate.vehicleDescription || vehicleName,
    },
  ]

  let releaseMoreExpensive = false
  let releaseBannerText
  if (props.estimate.vehicle.vehicleType == 'Residual Release')
    releaseBannerText =
      'Keep your car and extend your lease from an estimated ' +
      formatCurrency(
        Math.abs(props.estimate.differenceInOutOfPocketCostPerPay)
      ) +
      ' less per pay packet'
  else {
    if (props.estimate.differenceInOutOfPocketCostPerPay > 0) {
      releaseBannerText =
        'Upgrade to this car from an estimated ' +
        formatCurrency(props.estimate.differenceInOutOfPocketCostPerPay) +
        ' more per pay packet'
      releaseMoreExpensive = true
    } else {
      releaseBannerText =
        'Switch to this car for an estimated ' +
        formatCurrency(
          Math.abs(props.estimate.differenceInOutOfPocketCostPerPay)
        ) +
        ' less per pay packet'
    }
  }

  const CurrentCardHeader = isSpartaVehicle ? SpartaCardHeader : CardHeader
  return props.isHidden && (!props.estimate.isValid || invalid) ? (
    <></>
  ) : (
    <div>
      {isRelease && props.estimate.differenceInOutOfPocketCostPerPay && (
        <ReleaseCard positive={releaseMoreExpensive}>
          {releaseBannerText}
        </ReleaseCard>
      )}
      <EstimateItemStyled className='mb-5'>
        <div className={estimateCardHeaderClass()}>
          <CurrentCardHeader invalid={invalid}>
            {estimateCardHeaderText()}
          </CurrentCardHeader>
          <CardBody>
            <CarImageStyled>
              {props.estimate &&
                props.estimate.vehicle &&
                props.estimate.vehicle.id &&
                props.estimate.vehicle.vehicleImage && (
                  <ImageBase64
                    invalid={invalid}
                    ImageBase64Encoded={
                      props.estimate.vehicle.vehicleImage.base64Image
                    }
                  />
                )}
              {props.estimate &&
                props.estimate.vehicle &&
                (!props.estimate.vehicle.id ||
                  !props.estimate.vehicle.vehicleImage) && (
                  <img
                    src="/images/car-image-default.svg"
                    alt=""
                    style={{ opacity: invalid ? 0.5 : 1 }}
                  />
                )}
              {(isSpartaVehicle && !isProposal) || isEVRebate && (
                <SpartaBlock>
                  <SpartaCustomerCount
                    line1={line1}
                    line2={line2}
                    icon={icon}
                    extended={line2 == null}
                    spacingValue={1}
                  />
                </SpartaBlock>
              )}
            </CarImageStyled>
            <ImageText>Image is indicative only</ImageText>
            <Heading2
              style={{ minHeight: props.headerHeight, wordBreak: 'break-word' }}
              className="mt-3 text-center estimate-item__main--heading"
            >
              {vehicleName}
            </Heading2>
            <div className="text-center mt-4">
              <Link to={estimateDetailsURL} tabIndex={-1}>
                <EstimateItemPrimaryButton
                  extendInMob
                  isSparta={isSpartaVehicle && !invalid}
                >
                  View details
                </EstimateItemPrimaryButton>
              </Link>
            </div>
            <EstimateItemInfoBlock
              isSparta={isSpartaVehicle && !invalid}
              data={vehicleDescriptionContent}
              alignCenter={true}
              descFontWeight="normal"
              className="estimate-item__description"
              minHeight={props.vehicleDescHeight}
            />

            <Separator className="mt-3" />
            <div>
              <Row className="text-left row-spacing">
                <Col xs={4}>Lease type</Col>
                <Col xs={8} className="text-right font-weight-bold">
                  <span>{getLeaseType()}</span>
                </Col>
              </Row>
              <Separator />
              {props.estimate.fbtMethod && (
                <div>
                  <Row className="text-left row-spacing">
                    <Col xs={6}>FBT method</Col>
                    <Col xs={6} className="text-right font-weight-bold">
                      <span>{props.estimate.fbtMethod}</span>
                    </Col>
                  </Row>
                  <Separator />
                </div>
              )}
              {props.estimate.productId && (
                <div>
                  <Row className="text-left row-spacing">
                    <Col xs={6}>Your lease product type</Col>
                    <Col
                      xs={6}
                      className="text-right font-weight-bold"
                      style={{ paddingLeft: 0 }}
                    >
                      <span>
                        {capitalizeEachFirstLetter(
                          props.estimate.productId
                            .toLowerCase()
                            .replace('novated lease', '')
                            .trim()
                        )}
                      </span>
                    </Col>
                  </Row>
                  <Separator />
                </div>
              )}
              {props.estimate.priveawayPrice > 0 && (
                <div>
                  <Row className="text-left row-spacing">
                    <Col>Your Oly novated lease price</Col>
                    <Col className="text-right font-weight-bold">
                      {formatCurrency(props.estimate.priveawayPrice)}
                    </Col>
                  </Row>
                  <Separator />
                </div>
              )}
              <div className="row-spacing text-center">
                <div className="font-weight-bold">Lease term</div>
                <Heading2>{leaseTerm}</Heading2>
              </div>
              <Separator />
              <div className="txt-header mt-3 mb-3 rounded" style={{backgroundColor:'#F2EDE8'}}>
                <OlyCaption>Total Salary Packaging Deductions</OlyCaption>
                <OlyCaption>
                  {userEmployer &&
                    userEmployer.employerGRS &&
                    userEmployer.employerGRS.gstExclusiveDeductionsCode
                      .toString()
                      .toLowerCase() === 'no' && (
                      <p>
                        {formatCurrency(
                          props.estimate.totalPackagePerPayIncGST
                        )}
                      </p>
                    )}
                  {userEmployer &&
                    userEmployer.employerGRS &&
                    userEmployer.employerGRS.gstExclusiveDeductionsCode
                      .toString()
                      .toLowerCase() != 'no' && (
                      <p>
                        {formatCurrency(props.estimate.totalPackagePerPayExGST)}
                      </p>
                    )}
                </OlyCaption>

                <div className="mt-2 mb-2 text-center">
                  Less estimated Tax and Medicare Levy savings per pay
                </div>

                <div className="row-spacing text-center">
                  <OlyCaption>Estimated out of pocket</OlyCaption>
                  <br />
                  <ColoredBlock brand={"Oly"}>
                    <h2 className="mb-2">
                      {formatCurrency(props.estimate.outOfPocketPerPay)}
                    </h2>
                    <div>{userEmployer && userEmployer.payFrequency}</div>
                  </ColoredBlock>
                </div>

                <div className="text-center mt-2 mb-2">
                  Package includes car finance, registration, running costs and
                  more.
                </div>
              </div>

              <Separator />

              <div className="row-spacing text-center">
                <div className="estimate-item__savings">
                  Your estimated savings
                </div>
                <Heading2>
                  {formatCurrency(props.estimate.lifeOfLeaseTaxSaving)}
                </Heading2>
                <span className="estimate-item__normal-black">
                  Over life of lease
                </span>
              </div>

              <Separator className="mb-3" />

              <p className="mb-3 font-weight-bold">Your on the road budget</p>
              <div className="mb-3">
                <div className="font-weight-bold">
                  You've estimated you'll drive:
                </div>
                <div className="estimate-item__normal-black">
                  {props.estimate.kmPerAnnum} km/year
                </div>
              </div>
              {userEmployer &&
                userEmployer.employerGRS &&
                userEmployer.employerGRS.gstExclusiveDeductionsCode
                  .toString()
                  .toLowerCase() === 'no' && (
                  <div className="mb-3">
                    <div className="font-weight-bold">
                      Giving you a convenient on road budget of:
                    </div>
                    <div className="estimate-item__normal-black">
                      {formatCurrency(props.estimate.runningCostsPerPayIncGST)}
                      {userEmployer.payFrequency && (
                        <span>
                          /
                          {userEmployer.payFrequency
                            .toString()
                            .replace('ly', '')}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              {userEmployer &&
                userEmployer.employerGRS &&
                userEmployer.employerGRS.gstExclusiveDeductionsCode
                  .toString()
                  .toLowerCase() !== 'no' && (
                  <div className="mb-3">
                    <div className="font-weight-bold">
                      Giving you a convenient on road budget of:
                    </div>
                    <div className="estimate-item__normal-black">
                      {formatCurrency(props.estimate.runningCostsPerPayExGST)}
                      {userEmployer.payFrequency && (
                        <span>
                          /
                          {userEmployer.payFrequency
                            .toString()
                            .replace('ly', '')}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              <div className="mb-2">
                <p className="font-weight-bold">Your total amount financed:</p>
                <div className="font-weight-bold">Giving you access to:</div>
                <TickItem text="Potential tax benefits for the life of the lease" />
                <TickItem text="No upfront costs on the car" />
                <TickItem text="Your on the road budget" />
                <TickItem text="Insurance options" />
              </div>
            </div>
            <Heading3>Total amount financed</Heading3>
            <Heading2>{formatCurrency(props.estimate.financeAmount)}</Heading2>
            <Heading3>Total residual value</Heading3>
            <Heading2>
              {formatCurrency(props.estimate.leaseResidualAmountIncGST)}
            </Heading2>
            <Heading3> Residual percentage</Heading3>
            <Heading2>
              {props.estimate.residualPCT && (
                <span> {props.estimate.residualPCT}%</span>
              )}
            </Heading2>
            <Separator className="mb-3" />
            <div className="mb-4 mt-2 text-center">
              <Link to={estimateDetailsURL} tabIndex={-1}>
                <EstimateItemPrimaryButton
                  extendInMob
                  isSparta={isSpartaVehicle && !invalid}
                >
                  View details
                </EstimateItemPrimaryButton>
              </Link>
            </div>
            <div className="text-center">
              {props.applicationRole &&
                props.applicationRole !== applicationRoles.CONSULTANT && (
                  <LinkContainer isSparta={isSpartaVehicle && !invalid}>
                    <ContactUsDialog
                      className="link"
                      theme="link"
                      launchText="Contact your consultant"
                      disabled={props.isConsultant}
                    />
                  </LinkContainer>
                )}
              {props.applicationRole &&
                props.applicationRole === applicationRoles.CONSULTANT && (
                  <a className="link text-underline readonly">
                    Contact your consultant
                  </a>
                )}
            </div>

            <div className="text-center">
              Updated{' '}
              {new Date(props.estimate.updatedOn).toLocaleString('en-AU')}
            </div>
          </CardBody>
        </div>
      </EstimateItemStyled>
    </div>
  )
}

export default EstimateItem
